var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('sarala-table',{ref:"table",attrs:{"model":_vm.model},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var item = ref.item;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","tile":"","to":{
                                    name: _vm.$t('routes.mail.edit'),
                                    params: { id: item.id },
                                }}},on),[_c('v-icon',_vm._g({attrs:{"color":"blue-grey"}},on),[_vm._v("mdi-pencil")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('resources.default.edit')))])])]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }